import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoLinkedIn = () => {
  return (
    <g>
      <path d="M14.816 0H1.18A1.168 1.168 0 0 0 0 1.154v13.691A1.168 1.168 0 0 0 1.18 16h13.636A1.17 1.17 0 0 0 16 14.845V1.154A1.17 1.17 0 0 0 14.816 0zM4.746 13.633H2.37V5.998h2.376v7.635zM3.559 4.955a1.376 1.376 0 1 1-.002-2.752 1.376 1.376 0 0 1 .002 2.752zm10.076 8.679h-2.373V9.92c0-.886-.015-2.025-1.233-2.025-1.235 0-1.423.965-1.423 1.961v3.777H6.235V5.998H8.51v1.044h.032a2.493 2.493 0 0 1 2.246-1.233c2.402 0 2.846 1.581 2.846 3.637v4.188z" />
    </g>
  );
};

export default withIcon(IconLogoLinkedIn);
